import { h } from 'preact'
import Table from '../table/Table'

type Error = {
  row: number,
  type: string,
  error: string
}

type Props = {
  errors: Error[]
}

const ImportErrors = ({ errors }: Props) => {
  const model = [
    {
      header: 'Row',
      accessor: 'row',
      size: 'xs'
    },
    {
      header: 'Column name',
      accessor: 'type'
    },
    {
      header: 'Error',
      accessor: 'error'
    }]

  return (
    <div className='import-errors'>
      <h3>Errors</h3>
      <Table model={model} rows={errors} staticWidth />
    </div>
  )
}

export default ImportErrors
